import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import routes from "../../routes";
import ErrorPageMobile from "../../containers/Miscellaneous/ErrorPageMobile";

export class PageContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <>
                <Switch>
                    {routes.map((route, index) => {
                        return (
                            route.component && (

                                <Route
                                    path={route.path}
                                    key={index}
                                    exact={route.exact}
                                    // component={() => <route.component {...this.props} />}
                                    component={route.component}
                                />

                            )
                        );
                    })}
                    <Route component={ErrorPageMobile} />
                </Switch>
                {this.props.seoHeading && (
                    <div className="seo-page-heading-section">
                        <h1 className="seo-page-heading">{this.props.seoHeading}</h1>
                    </div>
                )}
            </>
        );
    }
}

export default PageContent;
